import React   from 'react'; 
import 'scss/components/page-components/Page.scss';
import classnames from 'classnames';

const Page = (props) => {
    let classes = classnames(
        props.className , 
        'L_Page_Content' , 
        { 'fullwidth' : props.fullwidth } ,
        { 'notFullwidth' : !props.fullwidth } ,
    );

    const style = props.style || {};
    return  (
        <div className={classes}  style={style}>
            { props.children }
        </div> 
    );
}

export default Page;
   